var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcFemale(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "no-stroke",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.16627 10.8887C9.40993 10.8887 9.60745 11.0823 9.60745 11.3211V15.5668C9.60745 15.8056 9.40993 15.9992 9.16627 15.9992C8.92262 15.9992 8.7251 15.8056 8.7251 15.5668V11.3211C8.7251 11.0823 8.92262 10.8887 9.16627 10.8887Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "no-stroke",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.57471 14.1531C6.57471 13.9143 6.77223 13.7207 7.01588 13.7207H11.3174C11.561 13.7207 11.7585 13.9143 11.7585 14.1531C11.7585 14.392 11.561 14.5856 11.3174 14.5856H7.01588C6.77223 14.5856 6.57471 14.392 6.57471 14.1531Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "no-stroke",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.16645 10.457C11.8409 10.457 14.0194 8.31542 14.0194 5.66093C14.0194 3.00645 11.8409 0.864865 9.16645 0.864865C6.49203 0.864865 4.31351 3.00645 4.31351 5.66093C4.31351 8.31542 6.49203 10.457 9.16645 10.457ZM14.9017 5.66093C14.9017 8.78738 12.334 11.3219 9.16645 11.3219C5.99893 11.3219 3.43115 8.78738 3.43115 5.66093C3.43115 2.53449 5.99893 0 9.16645 0C12.334 0 14.9017 2.53449 14.9017 5.66093Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFemale);
export default __webpack_public_path__ + "static/media/ic-female.6fc1fdc51ba58243a0d843aec35ed44a.svg";
export { ForwardRef as ReactComponent };